var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.showImg)?_c('div',{class:_vm.prefixCls + '__img'},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]):_vm._e(),_vm._v(" "),_c('p',{class:_vm.prefixCls + '__desc'},[_vm._v(_vm._s(_vm.desc))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0124f93c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/empty/empty.vue
// module id = 804
// module chunks = 0 1 55